export default __webpack_public_path__ + "static/media/doneStep.c613c020.png";